class Image {
  constructor () {
    this.id = null
    this.path = null
    this.file_name = null
  }
}

export default Image
